export const GET_APPLICATION = 'GET_APPLICATION';
export const GET_APPLICATION_ERROR = 'GET_APPLICATION_ERROR';
export const GET_APPLICATION_SUCCESS = 'GET_APPLICATION_SUCCESS';
